// extracted by mini-css-extract-plugin
module.exports = {"pg-orders":"styles_pg-orders__3niqc"};